import { Injectable, signal } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class ServerStatusService {

  serverStatus = signal<'ok'|'unknown'|'maintenance'>('unknown');
  maintenanceBegin = signal<Date|null>(null);
  maintenanceDuration = signal<string|null>(null);

}
